import { useMemo } from 'react';

import Banner from '@zenbusiness/zui/Banner';
import dayjs from 'dayjs';

import { DELAY_SHOW_ACTIVATE_CARD_IN_DAYS } from '#client/constants/date';
import useCardsContext from '#client/hooks/useCardsContext';
import { BannerWrapperStyled } from '#client/pages/SharedStyles';
import { getDiffTime } from '#client/utils/date';
import { CARD_STATUS } from '#graphql/cards/constants';

const LOCK_BEFORE_24_HOURS = 'LOCK_BEFORE_24_HOURS';
const ACTIVATE_AFTER_5_DAYS = 'ACTIVATE_AFTER_5_DAYS';

export default function ActivateCardBanner() {
  const { physicalCard, cardsLoading } = useCardsContext();

  const banner = useMemo(() => {
    const { createdAt, status, activatable } = physicalCard || {};
    const isValidDate = dayjs(createdAt).isValid();
    if (!isValidDate) {
      return false;
    }

    const diffTime = getDiffTime(createdAt);

    // after 3 failed attempts, the card is locked for 24 hours
    const isLockBefore24Hours = activatable === false && status === CARD_STATUS.INACTIVE;
    if (isLockBefore24Hours) {
      return LOCK_BEFORE_24_HOURS;
    }

    // The Debit Card banner should be updated so that it does not show until 5 days
    // after the debit card was ordered
    const isActivateAfter5Days =
      activatable === true &&
      status === CARD_STATUS.INACTIVE &&
      diffTime >= DELAY_SHOW_ACTIVATE_CARD_IN_DAYS;
    if (isActivateAfter5Days) {
      return ACTIVATE_AFTER_5_DAYS;
    }

    return null;
  }, [physicalCard]);

  if (cardsLoading) {
    return undefined;
  }

  switch (banner) {
    case LOCK_BEFORE_24_HOURS:
      return (
        <BannerWrapperStyled>
          <Banner
            subtitle="After three failed activation attempts, we locked your physical card for security purposes. You can activate it again after 24 hours."
            title="Your card is locked for 24 hours"
          />
        </BannerWrapperStyled>
      );
    default:
      return null;
  }
}
